import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Button,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EventIcon from '@mui/icons-material/Event';
import axiosInstance from '../../lib/axios';
import { toast } from 'react-toastify';
import { format, addDays } from 'date-fns';

export default function Datepopup({ open, setOpen, selectedDate, selectedMeal, selectedDay, globalProperty }) {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
     const userId = sessionStorage.getItem('UserId');

    useEffect(() => {
        if (open) {
            const currentDate = new Date();
            const nextWeekDate = addDays(currentDate, 7);
            
            setFromDate(currentDate);
            setToDate(nextWeekDate);
        }
    }, [open]);

    const handleClose = () => {
        setOpen(false);
        setFromDate(null);
        setToDate(null);
    };

    const handleSubmit = async () => {
        if (!fromDate) {
            toast.error('Please select From Date');
            return;
        }
        
        if (!toDate) {
            toast.error('Please select To Date');
            return;
        }

        if (fromDate > toDate) {
            toast.error('From Date cannot be greater than To Date');
            return;
        }

        try {
            const formattedFromDate = format(fromDate, 'yyyy-MM-dd');
            const formattedToDate = format(toDate, 'yyyy-MM-dd');

            const payload = {
                "PropId": globalProperty || 2,
                "FromDt": formattedFromDate,
                "ToDt": formattedToDate,
                "CreatedBy": userId
            };

            console.log('Submitting payload:', payload);

            const response = await axiosInstance.post('MstFood/BulkDateWiseTrnFoodWeekCal', payload);
            
            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Data submitted successfully!');
                setOpen(false);
                setFromDate(null);
                setToDate(null);
            } else {
                toast.error(response.data.Message || 'Error submitting data');
            }
        } catch (error) {
            console.error('Error submitting dates:', error);
            toast.error(error.response?.data?.Message || 'Error submitting dates. Please try again.');
        }
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
       if (date) {
            const newToDate = addDays(date, 7);
            setToDate(newToDate);
        } else {
            setToDate(null);
        }
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const formatDisplayDate = (date) => {
        if (!date) return '';
        if (date instanceof Date) {
            return format(date, 'dd/MM/yyyy');
        }
        return date;
    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <EventIcon color="primary" />
                        Select Date Range
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 3 }}>
                        Please select from date and to date to submit the food week calendar data.
                    </DialogContentText>
                    
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label={
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <EventIcon fontSize="small" />
                                                From Date
                                            </Box>
                                        }
                                        value={fromDate}
                                        onChange={handleFromDateChange}
                                        format="dd/MM/yyyy"
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                            
                                                sx: { borderRadius: 2 },
                                                className: 'custom-textfield'
                                            }
                                        }}
                                        maxDate={toDate || undefined}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label={
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <EventIcon fontSize="small" />
                                                To Date
                                            </Box>
                                        }
                                        value={toDate}
                                        onChange={handleToDateChange}
                                        format="dd/MM/yyyy"
                                        slotProps={{
                                            textField: {
                                               variant: 'filled',
                                                fullWidth: true,
                                               
                                                sx: { borderRadius: 2 },
                                                className: 'custom-textfield'
                                            }
                                        }}
                                        minDate={fromDate || undefined}
                                    />
                                </LocalizationProvider>
                            </Grid>
                           
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 0 }}>
                    <Button 
                        onClick={handleClose}
                        variant="outlined"
                        color="inherit"
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleSubmit} 
                        variant="contained"
                        color="primary"
                        autoFocus
                        disabled={!fromDate || !toDate}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}